import React from 'react'
import * as R from 'ramda'

import { List } from 'components/shared/List/List'
import { TraitScoreCard } from '../../common/TraitScoreCard/TraitScoreCard'
import { TRAITS } from 'components/common/ScoreCard/ScoreCard'
import { getInterviewScoreTreshholds } from 'utils/score'
import { percentScore } from 'utils/stringFormat'
import { getTraitTranslation } from 'components/modals/TestsReportModal/tabs/helpers'

import styles from './TraitScoreCards.module.scss'

export const TraitScoreCards = ({ scores, traits, language }) => {
  const getSubtraitLabel = subtrait =>
    R.path(
      ['label', 0],
      getTraitTranslation(subtrait, R.prop(subtrait, scores), language),
    )

  return (
    <List className={styles.cards} direction="column">
      {R.map(({ label, trait }) => {
        const subscores = R.sort(
          R.descend(R.prop('score')),
          R.map(
            subtrait => ({
              label: getSubtraitLabel(subtrait),
              score: percentScore(R.prop(subtrait, scores)),
            }),
            TRAITS[trait],
          ),
        )

        return (
          <List.Item className={styles.card} key={trait}>
            <TraitScoreCard
              label={label}
              score={percentScore(scores[trait])}
              subscores={subscores}
              theme={getInterviewScoreTreshholds(scores[trait])}
            />
          </List.Item>
        )
      })(traits)}
    </List>
  )
}
